import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store";
import { initAuthListener } from "../store/slices/userSlice";
import { fetchUserOrganizations } from "../store/slices/orgSlice";
import { fetchAllTeamData, fetchUserTeamRole } from "../store/slices/teamSlice";
import { setUIRole, selectUIRole } from "../store/slices/uiSlice";
import { useAppSelector } from "../store/hooks";

export const useAppState = () => {
  const dispatch = useDispatch<AppDispatch>();
  const user = useAppSelector((state) => state?.user?.user);
  const userData = useAppSelector((state) => state?.user?.userData);
  const isAuthenticated = useAppSelector(
    (state) => state?.auth?.isAuthenticated
  );
  const currentOrg = useSelector(
    (state: RootState) => state?.organization?.currentOrganization
  );

  const currentTeam = useSelector(
    (state: RootState) => state?.team?.currentTeam
  );
  const uiRole = useSelector((state: RootState) => state?.ui?.uiRole);
  const calculatedUIRole = useSelector(selectUIRole);

  // Initialize auth listener
  useEffect(() => {
    const unsubscribe = initAuthListener(dispatch);
    return () => unsubscribe();
  }, [dispatch]);

  // Fetch organizations when user data is loaded (except for supporty_admin who doesn't need them)
  useEffect(() => {
    if (user && user.role !== "supporty_admin") {
      dispatch(
        fetchUserOrganizations({
          uid: user.uid,
          orgId: user.orgId,
        })
      );
    }
  }, [user, dispatch]);

  // Fetch teams when organization is selected (not needed for supporty_admin)
  useEffect(() => {
    // if (user && user.role !== "supporty_admin") {
    //   dispatch(
    //     fetchAllTeamData({
    //       orgId: user.orgId,
    //       userId: user.teamId,
    //       userRole: user.uiRole || user?.teamRole,
    //     })
    //   );
    // }
  }, [currentOrg, user, dispatch]);
  // Fetch teams when organization is selected (not needed for supporty_admin)
  useEffect(() => {
    if (currentTeam && user && user.role !== "supporty_admin") {
      dispatch(
        fetchUserTeamRole({
          orgId: user.orgId,
          teamId: currentTeam.id,
          userId: user.uid,
        })
      );
    }
  }, [currentOrg, user, currentTeam, dispatch]);

  // Update UI role when dependencies change
  useEffect(() => {
    if (calculatedUIRole !== uiRole) {
      dispatch(setUIRole(calculatedUIRole));
    }
  }, [calculatedUIRole, uiRole, dispatch]);

  // For regular users, need org and team. For admins, just need user data
  const isLoading =
    !user ||
    !userData ||
    (userData.role !== "supporty_admin" && (!currentOrg || !currentTeam));

  return {
    user,
    userData,
    currentOrg,
    currentTeam,
    uiRole,
    isAuthenticated,
    isAdmin: user?.role === "supporty_admin",
    isLoading,
  };
};
